import React, { useState, useEffect } from 'react';
import { Box, Typography, Divider, Link, LinearProgress } from '@mui/material';
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { fetchRealtimeUsers, fetchTopActiveCountries, fetchUsersPerMinute } from '../../api/analyticsApi';
import countryNameMap from '../../utils/countryNameMap';

const RealtimeOverview = () => {
  const [totalUsers, setTotalUsers] = useState(0);
  const [topCountries, setTopCountries] = useState([]);
  const [usersPerMinute, setUsersPerMinute] = useState([]);

  useEffect(() => {
    const updateData = async () => {
      const user = JSON.parse(localStorage.getItem("user"));
      const propertyId = user?.propertyId?.id;

      const count = await fetchRealtimeUsers(propertyId);
      const stats = await fetchTopActiveCountries(propertyId);
      const chart = await fetchUsersPerMinute(propertyId);

      console.log("Users per minute data:", chart);
      setTotalUsers(count);
      setTopCountries(stats || []);
      setUsersPerMinute(chart || []);
    };

    updateData(); // initial fetch
    const interval = setInterval(updateData, 10000); // update every 10 seconds

    return () => clearInterval(interval); // cleanup
  }, []);

  return (
    <Box p={2} borderRadius={2} boxShadow={1} bgcolor="white">
      <Typography variant="subtitle2" color="textSecondary" gutterBottom>
        USERS IN LAST 30 MINUTES
      </Typography>
      <Typography variant="h3" gutterBottom>
        {totalUsers}
      </Typography>

      <Typography variant="caption" color="textSecondary">
        USERS PER MINUTE
      </Typography>
      {usersPerMinute.length > 0 ? (
        <ResponsiveContainer width="100%" height={60}>
          <BarChart data={usersPerMinute}>
            <XAxis dataKey="minute" hide />
            <Tooltip />
            <Bar dataKey="users" fill="#1976d2" radius={[2, 2, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Typography variant="body2" color="textSecondary" mt={1}>
          No active data
        </Typography>
      )}

      <Box mt={2}>
        <Typography variant="caption" color="textSecondary" gutterBottom>
          TOP COUNTRIES
        </Typography>
        {topCountries.map((country, i) => (
          <Box key={i} mb={1}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box display="flex" alignItems="center" gap={1}>
                <img
                  src={`https://flagcdn.com/24x18/${country._id.toLowerCase()}.png`}
                  alt={country._id}
                  width={15}
                  height={12}
                  style={{ borderRadius: 2 }}
                />
                <Typography variant="body2">{countryNameMap[country._id] || country._id}</Typography>
              </Box>
              <Typography variant="body2">{country.count}</Typography>
            </Box>
            {topCountries[0] && (country.count / topCountries[0].count) > 0.01 && (
              <Box mt={0.5} height={3} width="100%" bgcolor="#eee">
                <Box
                  height="100%"
                  width={`${(country.count / topCountries[0].count) * 100}%`}
                  bgcolor="primary.main"
                />
              </Box>
            )}
          </Box>
        ))}
      </Box>

      <Divider sx={{ my: 1 }} />

      <Box textAlign="right">
        <Link href="#" underline="hover" color="primary">
          View realtime
        </Link>
      </Box>
    </Box>
  );
};

export default RealtimeOverview;
